/**
 * Faceted search - Inputs
 *
 * Prevent preselection after inputs are changed.
 */

var faceted_search_preselected_inputs_changed = false;

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let inputs = document.querySelectorAll('.js-facet-input');

    if (!form || !inputs.length) {
        return;
    }

    function inputClicked() {
        if (faceted_search_preselected_inputs_changed) {
            return;
        }

        if (this.getAttribute('data-preselected')) {
            // console.log('Preselected element was clicked!');

            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'preselect');
            input.setAttribute('value', 'off');

            form.appendChild(input);

            faceted_search_preselected_inputs_changed = true;
        }
    }

    inputs.forEach((input) => {
        input.addEventListener('click', inputClicked);
    });

    form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        let focused = document.activeElement;

        if (!focused) {
            return;
        }

        if (focused.type === 'checkbox') {
            event.preventDefault(); // Prevent form submission

            // Make checkboxes togglable with the Enter key
            focused.checked = !focused.checked;
            focused.dispatchEvent(new Event('change'));
            form.dispatchEvent(new Event('input'));
        }

        // Bonus
        if (focused.type === 'radio') {
            event.preventDefault(); // Prevent form submission
        }
    });
})();
